import { Component } from '@angular/core';
import { ListComponent } from 'src/app/common/component/list.component';
import { Transport } from '../service.model';

@Component({
	selector: 'app-services-list',
	templateUrl: './services-list.component.html',
	styleUrls: ['./services-list.component.css'],
})
export class ServicesListComponent extends ListComponent {
	protected apiType = 'bag';
	protected apiUrl = 'offer/service';
	filters: Record<string, Transport[]>;
	parameters = {
		transport: [
			{ enum: Transport.ALL, name: 'Wszystkie' },
			{ enum: Transport.BUS, name: 'Autokar' },
			{ enum: Transport.FLY, name: 'Lot' },
			{ enum: Transport.OWN_TRANSPORT, name: 'Dojazd Własny' },
		],
	};
	columnsDef = [
		{ col: 'id', header: 'ID' },
		{ col: 'code', header: 'Kod' },
		{ col: 'name', header: 'Nazwa' },
		{ col: 'serviceType', header: 'Typ' },
	];
	protected convertData(data) {
		return data.results.map((v) => {
			v.serviceType = v.serviceType.name;
			return v;
		});
	}
}
